// Test IDs for checkout (public flow).
export const CHECKOUT = {
	emailInput: 'checkout-email-input',
	firstNameInput: 'checkout-first-name-input',
	lastNameInput: 'checkout-last-name-input',
	addressInput: 'checkout-address-input',
	cityInput: 'checkout-city-input',
	zipInput: 'checkout-zip-input',
	countryInput: 'checkout-country-input',
	phoneInput: 'checkout-phone-input',
	quantityInput: 'checkout-quantity-input',
	submitButton: 'checkout-submit-button',
	productCard: 'checkout-product-card',
	totalAmount: 'checkout-total-amount',
	errorMessage: 'checkout-error-message',
	successMessage: 'checkout-success-message',
	statusBadge: 'checkout-status-badge',
};
